<section class="request-feature">
    <div class=" container d-flex flex-column flex-md-row vpy-6">
        <div class="d-flex flex-column align-items-center col-md-7 col-12 text-center">
            <div data-aos="zoom-in" class="home-heading" [class.lh-sm]="!isMobile">Our REQUEST Feature
            </div>
            <div data-aos="zoom-in" class="vmb-6 vmt-4 max-w-29" [class.lh-lg]="!isMobile">
                <p class="Muli">Whether you’re looking for a dupe or similar
                    vibes to a product you found online,
                    our REQUEST feature allows you to share a photo with your
                    stylist and we’ll help you find similar items within your price range and your style. </p>
                <p class="Muli my-3"> To get started, text REQUEST
                    and have a photo handy to
                    send to your stylist when she asks. We’ll handle the rest.</p>

                <p class="Muli">*This feature is currently in beta and all members receive 1 Free Request.
                    You can upgrade to VIP to receive additional requests at any time via text.</p>
            </div>
            <div data-aos="zoom-in" class="vmb-6 mx-auto">
                <q-button title="Try It Out" (click)="onSignup();"></q-button>
            </div>
        </div>
        <div class="d-flex col-12 col-md-5 justify-content-center video-height position-relative" [class.mb-3]="isMobile">
            <q-mobile-frame [content]="video"></q-mobile-frame>

            <ng-template #video>
                <video controls id="localVideoStream" class="w-100" src="https://firebasestorage.googleapis.com/v0/b/qatchcode-production.appspot.com/o/qatch-how-it-work%2Fwedding-dress.MP4?alt=media"
                 [muted]="'muted'" loop>
            </video>
            </ng-template>
           <div class="video-arrow">
            <img src="./assets/img/how-it-work/arrow.png" class="float-end" style="width: 79px !important;">
            <div class="arrow-text ">Press Play To See How It Works </div>
           </div>
        </div>

    </div>
</section>